var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconlyBoldMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Plus",
    "data-name": "Iconly/Bold/Plus",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M14.66,0C18.06,0,20,1.92,20,5.33h0v9.34C20,18.06,18.07,20,14.67,20H5.33C1.92,20,0,18.06,0,14.67H0V5.33C0,1.92,1.92,0,5.33,0h9.33ZM9.99,5.51a.828.828,0,0,0-.83.83h0V9.16H6.33a.82.82,0,0,0-.83.83.843.843,0,0,0,.83.84H9.16v2.83a.83.83,0,1,0,1.66,0h0V10.83h2.84a.843.843,0,0,0,.83-.84.828.828,0,0,0-.83-.83H10.82V6.34A.828.828,0,0,0,9.99,5.51Z",
    fill: "#446fa2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 11,
    height: 6,
    transform: "translate(4 3)",
    fill: "#446fa2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 11,
    height: 6,
    transform: "translate(4 11)",
    fill: "#446fa2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyBoldMinus);
export default __webpack_public_path__ + "static/media/Iconly-Bold-Minus.40da279d97e4e40bc6ee42e31ebf2b03.svg";
export { ForwardRef as ReactComponent };